import UiAdapter from 'Engine/base/ui/uiAdapter/BaseUiAdapter';
import EntryPoint from 'Engine/EntryPoint';
import eStateTypes from '../../enums/eStateTypes';

export default class UiAdapterExtended extends UiAdapter {
  initExtraStateHandlers() {
    this.extraStateHandlers = {
      [eStateTypes.EBST_IDLE]: () => {
        this.ControllerUi.showSpinButton();
        this.ControllerUi.setWin(EntryPoint.GameModel.totalWin);
      },
      [eStateTypes.EBST_REQUEST_ROLLING]: () => {
        this.ControllerUi.showSpinButton();
        this.ControllerUi.toggleSpinButton(false);
      },
      [eStateTypes.EBST_FREE_SPINS_IN]: () => {
        this.ControllerUi.showSpinButton();
      },
      [eStateTypes.EST_FREE_SPINS_ADD]: () => {
        this.hideUi();
        this.ControllerUi.showSpinButton();
      },
      [eStateTypes.EBST_FREE_SPINS_OUT]: () => {
        this.hideUi();
        this.ControllerUi.showSpinButton();
      },
      [eStateTypes.EST_COLOR_BOMB_ACTION]: () => {
        this.ControllerUi.toggleInfoButton(false);
      },
      [eStateTypes.EST_COLOR_BOMB_ITERATION]: () => {
        this.ControllerUi.toggleInfoButton(false);
      },
      [eStateTypes.EST_BOMB_FEATURE]: () => {
        this.ControllerUi.toggleInfoButton(false);
      },
      default: () => {
        this.ControllerUi.showSpinButton();
      }
    };
  }
}
